export default __webpack_public_path__ + "static/media/research_banner1.29007a9d.png";